import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/home/HeroSection';
import HowItWorks from '../components/home/HowItWorks';
import FeaturedDoctors from '../components/home/FeaturedDoctors';
import TrustIndicators from '../components/home/TrustIndicators';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';

function Home() {
  return (
    <div className="home-container bg-white">
      <Navbar />
      <HeroSection />
      <FeaturedDoctors />
      <HowItWorks />
      <TrustIndicators />
    </div>
  );
}

export default Home;
